import { ref, reactive, computed } from 'vue'

export function useReviewColors() {
  // Define HSL values for specific scores

  const score = ref(0)

  const hslValues = {
    0: { hue: 0, saturation: 84.2, lightness: 60.2 },
    3: { hue: 0, saturation: 84.2, lightness: 60.2 },
    4: { hue: 330.4, saturation: 81.2, lightness: 60.4 },
    5: { hue: 45.4, saturation: 93.4, lightness: 47.5 },
    6: { hue: 24.6, saturation: 95, lightness: 53.1 },
    7: { hue: 142.1, saturation: 70.6, lightness: 45.3 },
    8: { hue: 217.2, saturation: 91.2, lightness: 59.8 },
    9: { hue: 258.3, saturation: 89.5, lightness: 66.3 }
  }

  const interpolate = (value, min, max, start, end) => {
    return start + (end - start) * ((value - min) / (max - min))
  }

  const getBlendedColor = (score) => {
    const keys = Object.keys(hslValues)
      .map(Number)
      .sort((a, b) => a - b)
    let lowerKey = keys[0]
    let upperKey = keys[keys.length - 1]

    for (let i = 0; i < keys.length - 1; i++) {
      if (score >= keys[i] && score <= keys[i + 1]) {
        lowerKey = keys[i]
        upperKey = keys[i + 1]
        break
      }
    }

    const lowerColor = hslValues[lowerKey]
    const upperColor = hslValues[upperKey]

    const blendFactor = (score - lowerKey) / (upperKey - lowerKey)

    const hue = interpolateHue(lowerColor.hue, upperColor.hue, blendFactor)
    const saturation = interpolate(
      blendFactor,
      0,
      1,
      lowerColor.saturation,
      upperColor.saturation
    )
    const lightness = interpolate(
      blendFactor,
      0,
      1,
      lowerColor.lightness,
      upperColor.lightness
    )

    return `hsl(${Math.round(hue)}, ${Math.round(saturation)}%, ${Math.round(
      lightness
    )}%)`
  }

  const interpolateHue = (hue1, hue2, blendFactor) => {
    const d = hue2 - hue1
    if (d > 180) {
      hue1 += 360
    } else if (d < -180) {
      hue2 += 360
    }
    return (hue1 + blendFactor * (hue2 - hue1)) % 360
  }

  const hslColor = computed(() => {
    return getBlendedColor(score.value)
  })
  const scoreHsl = (score) => {
    if (score < 0) {
      return 'hsl(0,0,100%)'
    }
    return getBlendedColor(score)
  }

  const scoreHslShade = (score, lightnessMultiplier) => {
    const originalHsl = scoreHsl(score)
    const hslParts = originalHsl.match(/hsl\((\d+), (\d+)%, (\d+)%\)/)

    if (hslParts) {
      const [_, h, s, l] = hslParts
      const newLightness = Math.min(Math.max(l * lightnessMultiplier, 0), 100)
      return `hsl(${h}, ${s}%, ${newLightness}%)`
    }

    // Fallback color if parsing fails
    return originalHsl
  }

  return { score, hslColor, scoreHsl, hslValues, scoreHslShade }
}
